import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from '@node_modules/ngx-bootstrap/modal';
import { AllocationSheetsServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-history-status-modal',
  templateUrl: './history-status-modal.component.html',
  styleUrls: ['./history-status-modal.component.less'],
})
export class HistoryStatusModalComponent
  extends AppComponentBase
  implements OnInit {
  @Input() allocationSheetId: string;
  @ViewChild('historyStatusModal', { static: true }) modal: ModalDirective;

  history = [];

  constructor(
    injector: Injector,
    private _allocationSheetService: AllocationSheetsServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.allocationSheetId) {
      this.getStatusHistory();

      abp.event.on('app.evt.statusHistoryChanged', () => {
        this.getStatusHistory()
      });
    }
  }

  getStatusHistory(){
    this._allocationSheetService
    .getAllocationSheetStatusHistory(this.allocationSheetId)
    .subscribe((data) => {
      this.history = data.items;
    });
  }
  close() {
    this.modal.hide();
  }
}
